module.exports = __webpack_public_path__ + "img/Jaqueline.a2925add.png";